module.exports = __webpack_public_path__ + "img/sprite.979a972b.svg";